import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import { PercentageInput } from './Form';
import { PersonalPropertyItemFormValues } from './PersonalPropertyItemForm';

interface PersonalPropertyItemOwnershipAllocationInputProps {
  className?: string;
}

export const PersonalPropertyItemOwnershipAllocationInput: FC<PersonalPropertyItemOwnershipAllocationInputProps> = ({
  className,
}) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<PersonalPropertyItemFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<PersonalPropertyItemFormValues, 'ownershipAllocation'>({
    control,
    name: 'ownershipAllocation',
    rules: { required: true },
  });

  return (
    <PercentageInput
      {...field}
      decimalsLimit={3}
      className={className}
      allowNegativeValue={false}
      placeholder={tForm('general-required-placeholder')}
      label={tForm('general-ownership-allocation-input')}
      status={errors.ownershipAllocation ? 'errored' : 'normal'}
    />
  );
};
